import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.content.type},[_c(VIcon,{class:_vm.content.classes + ' content',style:('color:'+_vm.content.text_color),on:{"click":function($event){return _vm.set_icon(_vm.content)}}},[_vm._v(" "+_vm._s(_vm.content.icon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }